import React, { useEffect, useState } from 'react';
export function Countdown({
  initialMinutes = 5,
  initialSeconds = 0
}: {
  initialMinutes?: number;
  initialSeconds?: number;
}) {
  const [timeLeft, setTimeLeft] = useState(initialMinutes * 60 + initialSeconds);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="flex items-center gap-1 font-bold" data-id="element-30">
      <div className="bg-white/20 text-white px-2 py-0.5 rounded-md min-w-[32px] text-center" data-id="element-31">
        {minutes.toString().padStart(2, '0')}
      </div>
      <span className="text-white/80" data-id="element-32">:</span>
      <div className="bg-white/20 text-white px-2 py-0.5 rounded-md min-w-[32px] text-center" data-id="element-33">
        {seconds.toString().padStart(2, '0')}
      </div>
    </div>;
}
export function CountdownDark({
  initialMinutes = 5,
  initialSeconds = 0
}: {
  initialMinutes?: number;
  initialSeconds?: number;
}) {
  const [timeLeft, setTimeLeft] = useState(initialMinutes * 60 + initialSeconds);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="flex items-center gap-1 font-bold" data-id="element-34">
      <div className="bg-red-600 text-white px-2 py-0.5 rounded-md min-w-[32px] text-center" data-id="element-35">
        {minutes.toString().padStart(2, '0')}
      </div>
      <span className="text-red-600 font-bold" data-id="element-36">:</span>
      <div className="bg-red-600 text-white px-2 py-0.5 rounded-md min-w-[32px] text-center" data-id="element-37">
        {seconds.toString().padStart(2, '0')}
      </div>
    </div>;
}